const menu = {
	namespaced: true,
	state: {
		mini: {
			toggle: false,
			boing: false,
			boingBack: false
		}		
	},
	getters: {
		miniMenu(state){
			return state.mini
		}
	},
	mutations: {
		setMiniMenu(state, toggle){
			state.mini.toggle = toggle
		},
		setMiniMenuBoing(state, toggle){
			state.mini.boing = toggle
		},
		setMiniMenuBoingBack(state, toggle){
			state.mini.boingBack = toggle
		}
	},
	actions: {
		toggleMiniMenu({ commit }, toggle){
			commit('setMiniMenu', toggle)

			if(!toggle){
				commit('setMiniMenuBoingBack', false)
				setTimeout(() => {
					commit('setMiniMenuBoing', false)
				}, 400)
			}else{
				setTimeout(() => {
					commit('setMiniMenuBoingBack', true)
				}, 100)
					commit('setMiniMenuBoing', true)
			}
		}
	}
}

export default menu;


// WEBPACK FOOTER //
// ./src/store/menu.js